import Layout from '@/layout';
var samStoreRouter = {
  path: '/samStore',
  component: Layout,
  redirect: '/samStore/samSkuList',
  name: 'SamStore',
  meta: {
    title: '山姆管理',
    icon: 'shopping'
  },
  children: [{
    path: 'samSkuList',
    name: 'SamSkuList',
    component: function component() {
      return import('@/views/jdStore/samSkuList/index.vue');
    },
    meta: {
      title: '山姆SKU列表',
      icon: ''
    }
  }, {
    path: 'samSrot',
    name: 'SamSrot',
    component: function component() {
      return import('@/views/jdStore/samSrot/index.vue');
    },
    meta: {
      title: '山姆分类',
      icon: ''
    }
  }]
};
export default samStoreRouter;